// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/style.scss
// module id = 337
// module chunks = 0